export type IProductItem = {
    variantId: string;
    name?: string;
    desc: string;
    link: string;
    tips: string;
    save: string;
    noPanels?: boolean;
    detailsLink?: string;
    descList: string[];
    // 接口注入
    productTitle?: string;
    img?: string;
    price?: number;
    compareAtPrice?: number;
};

export const products: Record<string, IProductItem[]> = {
    eu: [
        {
            variantId: '50245703172439',
            tips: 'Flexible DIY Solar Network',
            desc: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            save: 'Capacity: 1.92kWh × 2',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703172439&purchaseOption=691099697495',
            descList: ['2,300W', '2,000W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50245703205207',
            tips: 'Ideal for 120–149m² Home Size',
            desc: '4 × 520W Rigid Solar Panels + EcoFlow STREAM Ultra',
            save: 'Save up to €595 annually',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703205207&purchaseOption=691099697495',
            descList: ['75%', '1,983kWh', '1,977 kg'],
        },

        {
            variantId: '50245703139671',
            tips: 'Ideal for 90–119m² Home Size',
            desc: '2 × 520W Rigid Solar Panels + EcoFlow STREAM Ultra',
            save: 'Save up to €385 annually',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703139671&purchaseOption=691099697495',
            descList: ['97%', '992kWh', '989 kg'],
        },

        {
            variantId: '50510963016023',
            tips: 'First Choice',
            name: 'STREAM Ultra',
            desc: '1 × EcoFlow STREAM Ultra',
            save: 'Capacity: 1.92kWh',
            link: '',
            detailsLink: 'https://eu.ecoflow.com/products/stream-ultra-pro?variant=50510963016023',
            descList: ['2,300W', '2,000W', 'IP65'],
            noPanels: true,
        },

        {
            variantId: '50245703237975',
            tips: 'Solar energy you can use any time',
            desc: '4 × 520W Rigid Solar Panels + EcoFlow STREAM Ultra + 2 × EcoFlow STREAM AC Pro',
            save: 'Save up to €761 annually',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703237975&purchaseOption=691099697495',
            descList: ['96%', '1,983kWh', '1,977 kg'],
        },
        // {
        //     variantId: '50245703270743',
        //     tips: 'Plug & Play Residential Solar Solution',
        //     desc: '4 × 520W Rigid Solar Panels + 2 × 450W Rigid Solar Panels + 2 × EcoFlow STREAM Ultra + 3 × EcoFlow STREAM AC Pro + 1 × Microinverter',
        //     save: 'Save up to €1.098 annually',
        //     link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703270743&purchaseOption=691099697495',
        //     descList: ['99%', '2,773kWh', '2,764 kg'],
        // },
    ],
    uk: [
        {
            variantId: '50633613836627',
            desc: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            tips: 'Flexible DIY Solar Network',
            save: 'Capacity: 1.92kWh × 2',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613836627&purchaseOption=690042765651',
            descList: ['2,300W', '2,000W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50633613869395',
            desc: '4 × 520W Rigid Solar Panels + EcoFlow STREAM Ultra',
            tips: 'Ideal for 120–149m² Home Size',
            save: 'Save up to £446 annually',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613869395&purchaseOption=690042765651',
            descList: ['75%', '1,983kWh', '1,977 kg'],
        },

        {
            variantId: '50633613803859',
            desc: '2 × 520W Rigid Solar Panels + EcoFlow STREAM Ultra',
            tips: 'Ideal for 90–119m² Home Size',
            save: 'Save up to £289 annually',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613803859&purchaseOption=690042765651',
            descList: ['97%', '992kWh', '989 kg'],
        },

        {
            variantId: '50839891116371',
            desc: '1 × EcoFlow STREAM Ultra',
            name: 'STREAM Ultra',
            tips: 'First Choice',
            save: 'Capacity: 1.92kWh',
            link: '',
            detailsLink: 'https://uk.ecoflow.com/products/stream-ultra-pro?variant=50839891116371',
            descList: ['2,300W', '2,000W', 'IP65'],
            noPanels: true,
        },

        {
            variantId: '50633613902163',
            desc: '4 × 520W Rigid Solar Panels + EcoFlow STREAM Ultra + 2 × EcoFlow STREAM AC Pro',
            tips: 'Solar energy you can use any time',
            save: 'Save up to £571 annually',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613902163&purchaseOption=690042765651',
            descList: ['96%', '1,983kWh', '1,977 kg'],
        },
        // {
        //     variantId: '50633613934931',
        //     desc: '4 × 520W Rigid Solar Panels + 2 × 450W Rigid Solar Panels + 2 × EcoFlow STREAM Ultra + 3 × EcoFlow STREAM AC Pro + 1 × Microinverter',
        //     tips: 'Plug & Play Residential Solar Solution',
        //     save: 'Save up to ￡824 annually',
        //     link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613934931&purchaseOption=690042765651',
        //     descList: ['99%', '2,773kWh', '2,764 kg'],
        // },
    ],
    de: [
        {
            variantId: '55583410618749',
            desc: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            tips: 'Flexibles DIY-Solarnetzwerk',
            save: 'Kapazität: 1,92kWh × 2',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410618749&purchaseOption=710509658493',
            descList: ['2 300 W', '2 000 W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '55583410651517',
            desc: '4 × 520 W Starres Solarpanel + EcoFlow STREAM Ultra',
            tips: 'Ideal für Wohnflächen von 120-149 m²',
            save: 'Bis zu 595 € jährlich sparen',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410651517&purchaseOption=710509658493',
            descList: ['75 %', '1 983 kWh', '1 977 kg'],
        },

        {
            variantId: '55583410585981',
            desc: '2 × 520 W Starres Solarpanel + EcoFlow STREAM Ultra',
            tips: 'Ideal für Wohnflächen von 90-119 m²',
            save: 'Bis zu 385 € jährlich sparen',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410585981&purchaseOption=710509658493',
            descList: ['97 %', '992 kWh', '989 kg'],
        },

        {
            variantId: '55835416199549',
            desc: '1 × EcoFlow STREAM Ultra',
            name: 'STREAM Ultra',
            tips: 'Top-Wahl',
            save: 'Kapazität: 1,92kWh',
            link: '',
            detailsLink: 'https://de.ecoflow.com/products/stream-ultra-pro?variant=55835416199549',
            descList: ['2 300 W', '2 000 W', 'IP65'],
            noPanels: true,
        },

        {
            variantId: '55583410684285',
            desc: '4 × 520 W Starres Solarpanel + EcoFlow STREAM Ultra + 2 × EcoFlow STREAM AC Pro',
            tips: 'Jederzeit Zugriff auf Solarenergie',
            save: 'Bis zu 761 € jährlich sparen',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410684285&purchaseOption=710509658493',
            descList: ['96 %', '1 983 kWh', '1 977 kg'],
        },
        // {
        //     variantId: '55583410717053',
        //     desc: '4 × 520 W Starres Solarpanel + 2 × 450 W Starres Solarpanel + 2 × EcoFlow STREAM Ultra + 3 × EcoFlow STREAM AC Pro + Mikro-Wechselrichter',
        //     tips: 'Plug & Play Solarlösung für Privathaushalte',
        //     save: 'Sparen Sie jährlich bis zu 1 098 €',
        //     link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410717053&purchaseOption=710509658493',
        //     descList: ['99 %', '2 773 kWh', '2 764 kg'],
        // },
    ],
    fr: [
        {
            variantId: '50286857093467',
            desc: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            tips: 'Réseau solaire flexible',
            save: `Capacité : 1,92kWh × 2`,
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857093467&purchaseOption=693334770011',
            descList: ['2 300 W', '2 000 W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50286857126235',
            desc: '4 panneaux solaires rigides 520 W + EcoFlow STREAM Ultra',
            tips: 'Idéal pour un logement de 120 à 149 m²',
            save: `Économisez jusqu'à 426 € par an`,
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857126235&purchaseOption=693334770011',
            descList: ['75 %', '2 840 kWh', '1 977 kg'],
        },

        {
            variantId: '50286857060699',
            desc: '2 panneaux solaires rigides 520 W + EcoFlow STREAM Ultra',
            tips: 'Idéal pour un logement de 90 à 119 m²',
            save: `Économisez jusqu'à 275 € par an`,
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857060699&purchaseOption=693334770011',
            descList: ['97 %', '1 420 kWh', '989 kg'],
        },

        {
            variantId: '50473938420059',
            desc: '1 EcoFlow STREAM Ultra',
            name: 'STREAM Ultra',
            tips: 'Premier Choix',
            save: `Capacité : 1,92kWh`,
            link: '',
            detailsLink: 'https://fr.ecoflow.com/products/stream-ultra-pro?variant=50473938420059',
            descList: ['2 300 W', '2 000 W', 'IP65'],
            noPanels: true,
        },

        {
            variantId: '50286857159003',
            desc: '4 panneaux solaires rigides 520 W + EcoFlow STREAM Ultra + 2 EcoFlow STREAM AC Pro',
            tips: `L'énergie solaire que vous pouvez utiliser à tout moment`,
            save: "jusqu'à 545 € par an.",
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857159003&purchaseOption=693334770011',
            descList: ['96 %', '2 840 kWh', '1 977 kg'],
        },
        // {
        //     variantId: '50286857191771',
        //     desc: '4 panneaux solaires rigides 520 W + 2 panneaux solaires rigides 450 W + 2 EcoFlow STREAM Ultra + 3 EcoFlow STREAM AC Pro + 1 micro-onduleur',
        //     tips: `Solution solaire résidentielle prête à l’emploi`,
        //     save: `Économisez jusqu'à 725 € par an`,
        //     link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857191771&purchaseOption=693334770011',
        //     descList: ['99 %', '3 660 kWh', '2 764 kg'],
        // },
    ],
    it: [
        {
            variantId: '54987832328568',
            desc: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            tips: 'Rete solare flessibile',
            save: 'Capacità: 1,92kWh × 2',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832328568&purchaseOption=710883574136',
            descList: ['2.300W', '2.000W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '54987832361336',
            desc: '4 pannelli solari rigidi da 520 W + EcoFlow STREAM Ultra',
            tips: 'Ideale per 120-149 m²',
            save: 'Risparmia fino a 446 € l’anno',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832361336&purchaseOption=710883574136',
            descList: ['75 %', '1.983 kWh', '1.977 kg'],
        },

        {
            variantId: '54987832295800',
            desc: '2 pannelli solari rigidi da 520 W + EcoFlow STREAM Ultra',
            tips: 'Ideale per abitazioni di 90-119 m²',
            save: 'Risparmia fino a 289 € l’anno',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832295800&purchaseOption=710883574136',
            descList: ['97 %', '992 kWh', '989 kg'],
        },

        {
            variantId: '55029709537656',
            desc: '1 EcoFlow STREAM Ultra',
            tips: 'La prima scelta',
            name: 'STREAM Ultra',
            save: 'Capacità: 1,92kWh',
            link: '',
            detailsLink: 'https://it.ecoflow.com/products/stream-ultra-pro?variant=55029709537656',
            descList: ['2.300W', '2.000W', 'IP65'],
            noPanels: true,
        },

        {
            variantId: '54987832394104',
            desc: '4 pannelli solari rigidi da 520 W + EcoFlow STREAM Ultra + 2 EcoFlow STREAM AC Pro',
            tips: 'Energia solare pronta all’uso in ogni istante',
            save: 'Risparmia fino a 571 € l’anno',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832394104&purchaseOption=710883574136',
            descList: ['96%', '1.983 kWh', '1.977 kg'],
        },
        // {
        //     variantId: '54987832426872',
        //     desc: '4 pannelli solari rigidi da 520 W + 2 pannelli solari rigidi da 450 W + 2 EcoFlow STREAM Ultra + 3 EcoFlow STREAM AC Pro + 1 microinverter',
        //     tips: 'Solare',
        //     save: 'Risparmia fino a 824 € l’anno',
        //     link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832426872&purchaseOption=710883574136',
        //     descList: ['99%', '2.773 kWh', '2.764 kg'],
        // },
    ],
    es: [
        {
            variantId: '50286854832475',
            desc: 'EcoFlow STREAM Ultra + STREAM AC Pro',
            tips: 'Red de energía solar fácil de instalar y flexible',
            save: 'Capacidad: 1,92 kWh × 2',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854832475&purchaseOption=693334802779',
            descList: ['2.300 W', '2.000 W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50286854865243',
            desc: '4 Paneles solares rígidos de 520 W + EcoFlow STREAM Ultra',
            tips: 'Ideal para un hogar de 120–149 m²',
            save: 'Ahorra hasta 223 € al año',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854865243&purchaseOption=693334802779',
            descList: ['75%', '1983 kWh ', '1977 kg'],
        },

        {
            variantId: '50286854799707',
            desc: '2 paneles solares rígidos de 520 W + EcoFlow STREAM Ultra',
            tips: 'Ideal para un hogar de un tamaño de 90–119 m²',
            save: 'Ahorra hasta 144 € al año',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854799707&purchaseOption=693334802779',
            descList: ['97%', '992 kWh ', '989 kg'],
        },

        {
            variantId: '50473803383131',
            desc: '1 EcoFlow STREAM Ultra',
            name: 'STREAM Ultra',
            tips: 'La mejor elección',
            save: 'Capacidad: 1,92 kWh',
            link: '',
            detailsLink: 'https://es.ecoflow.com/products/stream-ultra-pro?variant=50473803383131',
            descList: ['2.300 W', '2.000 W', 'IP65'],
            noPanels: true,
        },

        {
            variantId: '50286854898011',
            desc: '4 Paneles solares rígidos de 520 W + EcoFlow STREAM Ultra + 2 EcoFlow STREAM CA Pro',
            tips: 'Energía solar que puedes usar a cualquier hora',
            save: 'Ahorra hasta 286 € al año',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854898011&purchaseOption=693334802779',
            descList: ['96%', '1983 kWh ', '1977 kg'],
        },
        // {
        //     variantId: '50286854930779',
        //     desc: '4 Paneles solares rígidos de 520 W + 2 Paneles solares rígidos de 450 W + 2 EcoFlow STREAM Ultra + 3 EcoFlow STREAM AC Pro + 1 Inversor',
        //     tips: 'Solución de energía solar residencial fácil de instalar',
        //     save: 'Ahorra hasta 412 € al año',
        //     link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854930779&purchaseOption=693334802779',
        //     descList: ['99%', '2773 kWh ', '2764 kg'],
        // },
    ],
};
